import PausedPeriodDialog from './paused-period-dialog-container'
export default PausedPeriodDialog
